/* Contact 2026 (ENG-7787) — reveal animations + Gorgias mount fallback.
   Scoped to the .contact-2026 root. Degrades gracefully: with no
   IntersectionObserver, reveals everything at once. The CSS gates the hidden
   reveal state under html.js, so without this JS the content stays visible. */
(function () {
  var root = document.querySelector('.contact-2026');
  if (!root) return;

  /* ── Reveal on scroll ── */
  var els = root.querySelectorAll('.reveal');
  if (els.length) {
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
  }

  /* ── Gorgias mount fallback ──
     The form iframe is injected by Gorgias' remote loader. If that loader is
     down, blocked (ad-blocker), or slow, the mount would sit empty. Surface a
     mailto fallback only after a grace period, so a normal (fast) load never
     flashes the "trouble loading" copy. A MutationObserver hides it the moment
     the iframe mounts. */
  var mount = root.querySelector('.cu-widget-mount');
  var fallback = mount && mount.querySelector('.cu-widget-fallback');
  if (mount && fallback) {
    var isMounted = function () { return !!mount.querySelector('iframe'); };

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        if (isMounted()) {
          fallback.hidden = true;
          mo.disconnect();
        }
      });
      mo.observe(mount, { childList: true, subtree: true });
    }

    window.setTimeout(function () {
      if (!isMounted()) fallback.hidden = false;
    }, 6000);
  }
})();
